import React from 'react';
import { LockIcon, BookOpenIcon, ShieldCheckIcon, SparklesIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { CHECKOUT_URL, PRICE, TOTAL_VALUE, PRODUCT } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="border-y border-line bg-canvasAlt" data-id="element-83" data-mp="84xkgg0ja10n">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-14 text-center" data-id="element-84" data-mp="m46o6g7jz2nq">
        <Reveal data-id="element-85" data-mp="h659e7h5tpi2">
          <h2 id="cierre" className="font-display text-2xl md:text-4xl font-bold uppercase leading-[1.15] text-ink" data-id="element-86" data-mp="h6n8rcz4cju7">
            Tu camino puede empezar hoy
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm md:text-base leading-relaxed text-ink-muted" data-id="element-87" data-mp="qwq2xghz83u4">
            No necesitás comprender toda la Biblia de una vez. No necesitás
            estudiar durante horas. No necesitás esperar al momento perfecto.
            Podés empezar con un pasaje, una pregunta, una reflexión y una
            aplicación.
          </p>
          <p className="mx-auto mt-4 max-w-xl font-display text-lg md:text-xl font-bold leading-snug text-accent" data-id="element-88" data-mp="2h3hn6kmywq49">
            15 minutos. Paso a paso podés desarrollar una forma más clara y
            organizada de acercarte a las Escrituras.
          </p>
        </Reveal>

        <Reveal delay={0.05} className="mt-8 rounded-3xl border border-accent/25 bg-surface p-6 md:p-8" data-id="element-89" data-mp="2qzkpprlqeqrq">
          <span className="inline-flex items-center gap-2 rounded-full bg-gold-soft px-4 py-1.5 text-xs font-bold uppercase tracking-[0.18em] text-gold" data-id="element-90" data-mp="3023tcdxcd7f1">
            <SparklesIcon size={14} data-id="element-91" data-mp="34veymami9g4u" />
            Oferta activa
          </span>

          <p className="mt-4 flex items-center justify-center gap-2 font-display text-lg font-bold uppercase text-ink" data-id="element-92" data-mp="39rvpvdp04am5">
            <BookOpenIcon size={18} className="text-accent" data-id="element-93" data-mp="3epf3qchseldk" />
            {PRODUCT}
          </p>
          <p className="mt-1 text-sm text-ink-muted" data-id="element-94" data-mp="3ir0nmhsqnzx9">6 tomos + 6 bonos</p>

          <p className="mt-4 text-xs font-bold uppercase tracking-[0.2em] text-ink-subtle" data-id="element-95" data-mp="1jov2fxulqkfj">
            Valor total{' '}
            <span className="line-through decoration-danger" data-id="element-96" data-mp="1en5rsjbak8rz">
              {TOTAL_VALUE}
            </span>
          </p>
          <p className="mt-2 flex items-baseline justify-center gap-2" data-id="element-97" data-mp="1npyfkcl9m2d2">
            <span className="font-display text-5xl font-bold text-accent" data-id="element-98" data-mp="1nnu3v8h4jz28">
              {PRICE}
            </span>
            <span className="text-lg font-semibold text-ink-muted" data-id="element-99" data-mp="22gntvnu0vxl5">ARS</span>
          </p>
          <p className="mt-1 text-xs font-bold uppercase tracking-[0.24em] text-gold" data-id="element-100" data-mp="1xi493qr60rud">
            Pago único
          </p>

          <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-6" data-id="element-101" data-mp="27e7c0ytucuid">
            Quiero empezar hoy
          </CtaButton>

          <div className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-ink-muted" data-id="element-102" data-mp="h2jjp4kv49g4">
            <span className="flex items-center gap-1.5" data-id="element-103" data-mp="d1hg6bjwxb8c">
              <LockIcon size={14} className="text-ink-subtle" data-id="element-104" data-mp="2vg7py3oil9b" />
              Pago seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-105" data-mp="6xtcaj6owd4i">
              <ZapIcon size={14} className="text-gold" data-id="element-106" data-mp="6ze6u8t07w2d" />
              Acceso digital inmediato
            </span>
            <span className="flex items-center gap-1.5" data-id="element-107" data-mp="3uani6uvqp7gv">
              <ShieldCheckIcon size={14} className="text-success" data-id="element-108" data-mp="3u92qre4q24n8" />
              Garantía 7 días
            </span>
          </div>
        </Reveal>
      </div>
    </section>;
}